var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade-fast", appear: "" } }, [
    _c(
      "div",
      {
        ref: "container",
        class: {
          "b-modal": true,
          mobile: _vm.isMobile,
          scrollable: _vm.isActuallyScrollable,
          dark: _vm.darkBackground,
          large: _vm.large,
          small: _vm.small,
          "no-radius": _vm.noBorderRadius,
          "refer-modal": _vm.isReferralModal,
          "subpack-modal": _vm.isSubpackModal,
          paywall: _vm.paywall && !_vm.isSubpackModal,
          legal: _vm.legal
        },
        style: _vm.modalStyle,
        on: { click: _vm.onClick, "subpack-button-clicked": _vm.close }
      },
      [
        _c(
          "div",
          { ref: "modal", staticClass: "b-modal-content" },
          [
            _vm.showCloseButton
              ? _c(
                  "span",
                  { staticClass: "close-trigger", on: { click: _vm.close } },
                  [_c("XIcon")],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._t("default")
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }